/*global SunergoPlatform*/

let itemOrderActionAdded = false;

/**
 * Initialize Item Order field.
 * @param {object} form 
 * @returns 
 */
const initItemOrder = function(form) {
	const fieldsets = form.element.querySelectorAll('[data-fieldset-type="itemOrder"]');
	if (!fieldsets || fieldsets.length < 1) return;

	let itemOrderAnimate = null;

	const moveItem = (item, newPosition, skipFocusDelay) => {
		if (itemOrderAnimate) return;

		const orderField = item.querySelector('[data-order]');

		const list = item.parentElement;
		const items = list.querySelectorAll('[data-order]');
		
		// If the item is being moved outside the list, stop moving.
		if (newPosition < 1 || newPosition > items.length) {
			if (newPosition < 1) newPosition = 1;
			if (newPosition > items.length) newPosition = items.length;
		}
		newPosition = parseInt(newPosition);

		const oldPosition = parseInt(orderField.dataset.order);
		if (oldPosition === newPosition) return;

		item.dataset.swapping = 'new';
		const dir = newPosition > oldPosition ? 'down' : 'up';
		
		// Swap with the other item.
		const swappedItemOrder = Array.from(items).find(item => item.value == newPosition);
		swappedItemOrder.value = oldPosition;
		swappedItemOrder.dataset.order = oldPosition;
		const swappedItem = swappedItemOrder.parentElement;
		swappedItem.dataset.swapping = 'old';

		// Disable buttons that lead out of bounds.
		item.querySelector('[data-dir="up"]').disabled = newPosition === 1;
		item.querySelector('[data-dir="down"]').disabled = newPosition === items.length;

		swappedItem.querySelector('[data-dir="up"]').disabled = oldPosition === 1;
		swappedItem.querySelector('[data-dir="down"]').disabled = oldPosition === items.length;


		// Get the move distance.
		const moveDistance = dir == 'up'
			? item.previousElementSibling.offsetHeight
			: item.nextElementSibling.offsetHeight;
		item.style.setProperty('--swap-move-distance', `${moveDistance}px`);

		// Set the item order.
		orderField.value = newPosition;
		orderField.dataset.order = newPosition;

		form.changeLog.checkChanges(orderField);

		clearTimeout(itemOrderAnimate);
		itemOrderAnimate = setTimeout(() => {
			item.dataset.swapDir = dir;
			swappedItem.dataset.swapDir = dir == 'up' ? 'down' : 'up';

			itemOrderAnimate = setTimeout(() => {
				list.insertBefore(swappedItem, dir =='up' ? item.nextElementSibling : item);
				item.removeAttribute('data-swap-dir');
				swappedItem.removeAttribute('data-swap-dir');

				itemOrderAnimate = setTimeout(() => {
					item.dataset.swapping = '';
					swappedItem.dataset.swapping = '';
					itemOrderAnimate = false;
				}, 50);
			}, 100);
		}, skipFocusDelay ? 0 : 75);
	};

	if (!itemOrderActionAdded) {
		SunergoPlatform.actionButtons.addAction(function(action, button) {
			if (action != 'item-order-move') return false;
			if (itemOrderAnimate) return true;
	
			// Get the item, direction and item order.
			const item = button.closest('[data-item-order="item"]');
			const dir = button.dataset.dir;
			const itemOrder = item.querySelector('[data-order]');
	
			// Get the item order of the item we are moving.
			const oldPosition = parseInt(itemOrder.value);
			let newPosition = dir == 'up' ? oldPosition - 1 : oldPosition + 1;
			moveItem(item, newPosition);
			return true;
		});
	}

	itemOrderActionAdded = true;

	fieldsets.forEach(function(fieldset) {
		fieldset.querySelectorAll('[data-item-order="item"]').forEach(function(item) {
			let itemFocused = false;

			const onKeyDown = function(e) {
				if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
				e.preventDefault();
				const itemOrder = item.querySelector('[data-order]');
				const oldPosition = parseInt(itemOrder.value);
				let newPosition = e.key === 'ArrowUp' ? oldPosition - 1 : oldPosition + 1;
				moveItem(item, newPosition, true);
			};

			const onBlur = function() {
				item.removeEventListener('keydown', onKeyDown);
				item.removeEventListener('blur', onBlur, true);
				itemFocused = false;
			};

			item.addEventListener('focus', function() {
				if (itemFocused) return;
				item.addEventListener('keydown', onKeyDown);
				item.addEventListener('blur', onBlur, true);
			}, true);
		});
	});
};

export default initItemOrder;